<template>
  <div class="content">
    <ArtistSelect
      @memberChangeEvent="getArtistInfo"
      :show-all-units="true"
      :is-filter="true"
      :show-members="false"
      :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
    />
    <div class="row">
      <div class="col-md-12">
        <el-table :data="events">
          <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
          <el-table-column :min-width="135" align="right" label="인기삭제">
            <div slot-scope="props">
              <base-button @click.native="removeHotSchedulePool(props.row.id)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-pencil" />
              </base-button>
            </div>
          </el-table-column>
          <el-table-column :min-width="135" align="right" label="상세">
            <div slot-scope="props">
              <base-button @click.native="onEventClick(props.row.id, props.row.unitId)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-pencil" />
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";

import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import * as moment from "moment";
import { URLUtils } from "@/util/URLUtils";
import { Alert } from "@/util/Alert";
import * as _ from "lodash";
import { showAPIErrorToast } from "../../util/ErrorUtils";

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();

export default {
  components: {
    ArtistSelect,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    await this.getScheduleTypes();
  },
  data() {
    return {
      unitId: "",
      memberId: "",
      keyword: null,
      currentMonth: null,
      year: y,
      month: m + 1,
      scheduleType: null,
      scheduleTypes: [],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "startTime",
          label: "시작일",
          minWidth: 150,
        },
        {
          prop: "endTime",
          label: "종료일",
          minWidth: 150,
        },
        {
          prop: "oriTitle",
          label: "제목",
          minWidth: 120,
        },
        {
          prop: "memberName",
          label: "관련멤버",
          minWidth: 120,
        },
        {
          prop: "type",
          label: "타입",
          minWidth: 120,
        },
      ],
      events: [],
    };
  },
  methods: {
    async getScheduleTypes() {
      return this.$axios.get("/schedule/scheduleTypes").then((res) => {
        this.scheduleTypes = res.data.data;
        this.scheduleTypes.unshift({ id: null, name: "전체" });
      });
    },
    onEventClick(id, unitId) {
      this.$router.push(`/schedules/scheduleForm?scheduleId=${id}&unitId=${unitId}`);
    },

    async removeHotSchedulePool(scheduleId) {
      if (await Alert.dangerousConfirmCancel("인기 풀에서 제거 하시겠어요?")) {
        try {
          await this.$axios.delete(`/schedule/${this.unitId}/hot/${scheduleId}`);
          window.Toast.success("인기 풀에서 제거 됐습니다");
        } catch (err) {
          showAPIErrorToast(err);
        } finally {
          await this.getHotSchedulePool();
        }
      }
    },

    async getArtistInfo(param) {
      this.unitId = param.unitId;
      await this.getHotSchedulePool();
    },

    async getHotSchedulePool() {
      if (this.unitId !== null && !this.unitId) {
        return;
      }

      const queryParams = {
        unitId: this.unitId || undefined,
      };
      if (this.unitId !== null) {
        const path = `/schedules/hotSchedulePool?${URLUtils.objectToQueryString(queryParams)}`;
        if (this.$route.fullPath !== path) {
          try {
            await this.$router.push(path);
          } catch (ex) {}
        }
      }
      return this.$axios.get(`/schedule/${this.unitId}/hot`).then((res) => {
        this.events = [];
        const data = res.data.data;
        data.forEach((d) => {
          const obj = {};

          for (let i = 0; i < this.scheduleTypes.length; i++) {
            const type = this.scheduleTypes[i];
            if (d.typeId === type.id) {
              obj.type = type.name;
              break;
            }
          }
          obj.id = d.scheduleId;
          if (this.unitId) {
            obj.title = `[${obj.type}] ${d.title}`;
          } else {
            obj.title = `[${obj.type} ${d.artistName}] ${d.title}`;
          }
          obj.unitId = d.unitId;
          obj.oriTitle = d.title;
          obj.allDay = d.isAllDay === 1;
          obj.members = d.members;
          obj.start = moment(d.startTime).format("Y-MM-DDTHH:mm:ss.000Z");
          obj.end = moment(d.endTime).format("Y-MM-DDTHH:mm:ss.100Z");
          obj.startTime = moment(d.startTime).format("Y-MM-DD HH:mm:ss");
          obj.endTime = moment(d.endTime).format("Y-MM-DD HH:mm:ss");
          if (obj.members.length > 0) {
            obj.memberName = "";

            obj.members.forEach((item) => {
              obj.memberName += item.name;
            });
          } else {
            obj.memberName = "전체";
          }
          this.events.push(obj);
        });
      });
    },
  },
};
</script>
<style>
.el-loading-spinner .path {
  stroke: #66615b !important;
}
</style>
